import { resolveChain, registry } from './chunk-R5ZQC5YM.js';

// src/chains/address-ref.ts
function nativeColons(raw) {
  if (/^-?\d+:[0-9a-fA-F]{64}$/.test(raw) || /^0x[0-9a-fA-F]+::/.test(raw)) return true;
  const parts = raw.split(":");
  return parts.length === 2 && registry.all().some((chain) => chain.cashaddrPrefix === parts[0]?.toLowerCase());
}
function parseAddressReference(value) {
  const raw = (value ?? "").trim();
  if (nativeColons(raw)) return { address: raw, chain: null };
  const first = raw.indexOf(":");
  if (first < 0) return { address: raw, chain: null };
  const alias = raw.slice(0, first);
  const native = raw.slice(first + 1);
  if (resolveChain(alias) && nativeColons(native)) {
    return { chain: alias, address: native };
  }
  const second = raw.indexOf(":", first + 1);
  if (second > first + 1 && /^[a-z0-9-]{3,8}:[^:]+$/.test(raw.slice(0, second))) {
    return { chain: raw.slice(0, second), address: raw.slice(second + 1) };
  }
  return { chain: alias, address: native };
}

export { parseAddressReference };
//# sourceMappingURL=chunk-VUDHYNBT.js.map
//# sourceMappingURL=chunk-VUDHYNBT.js.map